<div class="snackbar-confirm">
  <div class="message-container">
    <img
      src="../../../../assets/images/snack-bar/confirmation.svg"
      alt="confirm icon"
      width="40px"
      height="40px"
    />
    <div class="message">
      <div class="message__text">{{ text | capitalLetter }}</div>
    </div>
    <button mat-button class="message__btn-cancel" (click)="close(false)">
      NO
    </button>
    <button mat-button class="message__btn-ok" (click)="close(true)">
      YES
    </button>
  </div>
</div>
